import React from 'react'
import cn from 'classnames'

import placeholder from 'components/AsyncProfilePicture/placeholder.jpg'
import ConditionalWrapper from 'components/ConditionalWrapper/ConditionalWrapper'
import Heading from 'components/Heading/Heading'
import Link from 'components/Link/Link'
import Spinner from 'components/Spinner/Spinner'
import useResponsive from 'hooks/useResponsive'

import styles from './ProfileNameAndTitle.module.css'

const PropWithLoader = ({ loading, prop }) => {
  if (!prop && loading) {
    return <Spinner />
  }
  return prop || null
}

export default function ProfileNameAndTitle({
  profile,
  titleBelow = false,
  color = 'light',
  loading = false,
  nameIsMainHeading = true,
  ...props
}) {
  const { isMobile } = useResponsive()
  const imageUrl =
    profile?.profilePicture?.avatarUrl || profile?.profilePicture?.cardUrl

  const HeadingElement = ({ children }) => {
    return nameIsMainHeading ? <h1>{children}</h1> : <h2>{children}</h2>
  }

  return (
    <ConditionalWrapper
      wrapper={(children) => {
        return (
          <Link href={`/profile/${profile?.slug}`}>
            <a>{children}</a>
          </Link>
        )
      }}
      condition={profile?.slug}
    >
      <section
        className={cn(styles.base, {
          [styles.dark]: color === 'dark',
        })}
        {...props}
      >
        <div className={styles.content}>
          <img
            src={imageUrl || placeholder}
            alt=""
            className={styles.image}
            width={50}
          />
          <div>
            <Heading level={isMobile ? 'h3' : 'h1'} color={color} noMargin>
              <HeadingElement>
                <PropWithLoader prop={profile?.name} loading={loading} />
              </HeadingElement>
            </Heading>
            {!titleBelow && (
              <div className={styles.title}>{profile?.title}</div>
            )}
          </div>
        </div>
        {titleBelow && (
          <div className={styles.titleBelow}>{profile?.title}</div>
        )}
      </section>
    </ConditionalWrapper>
  )
}
